package com.milta.feature.admin.domain.usecase

import com.milta.feature.admin.domain.entity.AdminClaudeUsageEvents
import com.milta.feature.admin.domain.entity.AdminClaudeUsagePeriod
import com.milta.feature.admin.domain.repository.AdminRepository

class GetAdminClaudeUsageEventsUseCase(private val repository: AdminRepository) {
    suspend operator fun invoke(
        accountId: String, period: AdminClaudeUsagePeriod, page: Int, pageSize: Int,
    ): Result<AdminClaudeUsageEvents> = repository.getClaudeUsageEvents(accountId, period, page, pageSize)
}
